import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconOpt: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"opt, option, key"} maskId="square-filled-radius-0-stroke-1-IconOpt"><path fillRule="evenodd" clipRule="evenodd" d="M3 4H8.3L16.3 19H21V20H15.7L7.7 5H3V4ZM16 4H21V5H16V4Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconOpt;
